var map = {
	"./benefit1.svg": 280,
	"./benefit2.svg": 39115,
	"./benefit3.svg": 33850,
	"./benefit4.svg": 68773,
	"./benefit5.svg": 90756,
	"./benefit6.svg": 95351,
	"./benefit7.svg": 32550,
	"./benefit8.svg": 30705,
	"./no-vip-benefit1.svg": 74172,
	"./no-vip-benefit2.svg": 76495,
	"./no-vip-benefit3.svg": 56446,
	"./no-vip-benefit4.svg": 73825,
	"./platform1.svg": 52288,
	"./platform2.svg": 59379,
	"./platform3.svg": 28802,
	"./platform4.svg": 38093,
	"./platform5.svg": 2636,
	"./platform6.svg": 81663,
	"./vip-benefit1.svg": 48974,
	"./vip-benefit10.svg": 16770,
	"./vip-benefit11.svg": 4147,
	"./vip-benefit12.svg": 59488,
	"./vip-benefit2.svg": 43341,
	"./vip-benefit3.svg": 7884,
	"./vip-benefit4.svg": 64627,
	"./vip-benefit5.svg": 34050,
	"./vip-benefit6.svg": 14449,
	"./vip-benefit7.svg": 73888,
	"./vip-benefit8.svg": 79095,
	"./vip-benefit9.svg": 16294,
	"./vip-top-star.svg": 77550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31212;